import { Component, ElementRef, OnInit, Input, ViewChild } from '@angular/core';
import { CfChartComponent } from '../chart/chart.component';
import { NumberChartModel } from '../../models/chart/number-chart.model';
import { NumberChartTemplates } from '../../templates/number-chart.template';
import { ChartStylingModel } from '../../models/chart/chart-styling.model';
import { TemplateService } from '../../services/template-service/template.service';
import { CfEventService } from '../../services/event-service/event.service';
/**
 * <p>CfNumberChart component is created based on <a href="https://github.com/swimlane/ngx-charts" target="_blank">Ngx-charts</a></b>
 * and <b>CfChartComponet</b></p>
 * <code><pre>
 * import {{'{'}} PieChartModel {{'}'}} from 'cedrus-fusion'
 * import {{'{'}} ChartStylingModel {{'}'}} from 'cedrus-fusion'
 * <code><</code>cf-number-chart<code>></code><code><</code><code>/</code>cf-number-chart<code>></code>
 * </pre></code>
 * <code><pre>{{'{'}}
 * 	data: any[], 										// Data to show
 *  view: number[]                  // Dimensions of chart [width, height] by px
 * 	gradient: boolean, 							// Fill elements with a gradient instead of a solid color. Default: false.
 * 	showLegend: boolean, 						// If to show the legend. Default: true.
 * 	colorScheme: ChartsColorScheme, // Array with string css color values. Default: ['#5AA454', '#A10A28', '#C7B42C', '#AAAAAA'].
 * 	showXAxis: boolean, 						// If to show the x axis. Default: true.
 * 	showYAxis: boolean, 						// If to show the y axis. Default: true.
 * 	showXAxisLabel: boolean, 				// If to show the x axis label. Default: true.
 * 	showYAxisLabel: boolean, 				// If to show the y axis label. Default: true.
 * 	xAxisLabel: string, 						// The x axis label
 * 	yAxisLabel: string, 						// The y axis label
 * 	donut: boolean,									// Should pie chart to be like normal circle (true) or filled circle(false). Default: false.
 * 	showLabels: boolean,						// Show or hide the labels. Default: true.
 * 	explodeSlices: boolean,					// Make the radius of each slice proportional to it's value. Default: false.
 * 	legendPosition: string,					// Legend position. Can be: top, right, bottom, left. Default: right.
 * 	chartAlignment: string,					// Alignment of chart. Can be: start, center, end. Default: start.
 * {{'}'}}</pre></code>
 * <p>Example of data object:</p>
 * <code><pre>data = [
 *  {{'{'}} "name": "Germany", "value": 8940000 {{'}'}},
 *  {{'{'}} "name": "USA", "value": 5000000 {{'}'}},
 *  {{'{'}} "name": "France", "value": 7200000 {{'}'}}
 * ]</pre></code>
 * <p>Example of chart options:</p>
 * <code><pre>myChartModel = new PieChartModel({{'{'}}
 * 	data: this.data,
 * 	donut: true,
 * 	explodeSlices: true
 * {{'}'}});</pre></code>
 * <code><pre>{{'{'}}
 * 	barsContainerWidth: string, 							// It is css value for chart bars container width. Default: 100%.
 * 	barsContainerHeight: string', 						// It is css value for chart bars container height. Default: 200px.
 * 	container: StylingObject, 	              // Styling of chart container
 * {{'}'}}</pre></code>
 * <p>Example of styling object:</p>
 * <code><pre>chartStylingModel = new ChartStylingModel({{'{'}}
 * 	barsContainerWidth: '100%',
 * 	barsContainerHeight: '200px',
 * 	container: {{'{'}}
 * 		class: 'my-chart-class'
 * 	{{'}'}}
 * {{'}'}});</pre></code>
 */
export class CfNumberChartComponent extends CfChartComponent implements OnInit {
/**
 * @hidden
 */
cfChartHost;
/**
 * @hidden
 */
cfNgxChart;
/**
 * Background color for each data item card
 * @param {?} value
 * @return {?}
 */
set backgroundColor(value: string) { this.properties.backgroundColor = value; }
/**
 * Background color for each data item card, when data is not defined (empty)
 * @param {?} value
 * @return {?}
 */
set emptyBackgroundColor(value: string) { this.properties.emptyBackgroundColor = value; }
/**
 * Text color for each data item card
 * @param {?} value
 * @return {?}
 */
set textColor(value: string) { this.properties.textColor = value; }
/**
 * @hidden
 * @param {?} elementRef
 * @param {?} templateService
 * @param {?} eventService
 */
constructor(public elementRef: ElementRef,
                /**@hidden */ templateService: TemplateService,
public eventService: CfEventService) {
    super(elementRef, templateService, eventService);
    this.properties = new NumberChartModel();
  }
/**
 * @hidden
 * @return {?}
 */
ngOnInit(): void {
    super.ngOnInit();
    this.getMyTemplate('number-chart', NumberChartTemplates).then(() => {
      this.mergeProperties(this.activeTemplate.property, this.properties, 'number-chart').then( sampler => {
        if (this.properties.colorScheme.domain.length === 0) {
          this.properties.colorScheme = this.colorSchemes.find(s => s.name === this.properties.colorSchemeName);
        }
        this.styling = new ChartStylingModel(Object.assign({}, this.activeTemplate.style, this.styling));
        // console.log('number-chart', this);
      });
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'cf-number-chart',
  template: "<div *ngIf=\"_inited && properties?.display\" [class]=\"styling?.container?.class\" [ngClass]=\"getDynamicClasses(styling?.container?.dynamicClass)\"> <div #cfChartHost [style.height]=\"updateChartHeight(cfNgxChart?.chartElement?.nativeElement?.scrollHeight)\"> <cf-chart [style.width]=\"styling?.barsContainerWidth\" [style.height]=\"styling?.barsContainerHeight\" class=\"{{properties.legendPosition}} {{properties.chartAlignment}}\"> <ng-template #cfComponentChartTemplate> <ngx-charts-number-card #cfNgxChart class=\"cf-chart-zone\" [view]=\"properties?.view\" [cardColor]=\"properties?.backgroundColor\" [emptyColor]=\"properties?.emptyBackgroundColor\" [textColor]=\"properties?.textColor\" [scheme]=\"properties?.colorScheme\" [results]=\"properties?.data\" (select)=\"onSelect($event)\"> </ngx-charts-number-card> </ng-template> </cf-chart> </div> </div> ",
  styles: [""]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: TemplateService, },
{type: CfEventService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'cfChartHost': [{ type: ViewChild, args: ['cfChartHost', ] },],
'cfNgxChart': [{ type: ViewChild, args: ['cfNgxChart', ] },],
'backgroundColor': [{ type: Input, args: ['backgroundColor', ] },],
'emptyBackgroundColor': [{ type: Input, args: ['emptyBackgroundColor', ] },],
'textColor': [{ type: Input, args: ['textColor', ] },],
};
}

function CfNumberChartComponent_tsickle_Closure_declarations() {
/** @type {?} */
CfNumberChartComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CfNumberChartComponent.ctorParameters;
/** @type {?} */
CfNumberChartComponent.propDecorators;
/**
 * @hidden
 * @type {?}
 */
CfNumberChartComponent.prototype.cfChartHost;
/**
 * @hidden
 * @type {?}
 */
CfNumberChartComponent.prototype.cfNgxChart;
/** @type {?} */
CfNumberChartComponent.prototype.elementRef;
/**
 * @hidden
 * @type {?}
 */
CfNumberChartComponent.prototype.eventService;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
